import { useNavigation, useRoute } from '@react-navigation/native';
import { styled, SxProp } from 'dripsy';
import React, { useMemo, useState } from 'react';
import { View } from 'react-native';
import Fuse from 'fuse.js';
import { useTranslation } from 'react-i18next';

import { AppNavigatorRoutePropType } from '@navigation';
import {
  Touchable,
  TextInput,
  Line,
  FlatList,
  BaseText,
  Separator,
} from '@components';
import { useEventEmitter, useNavOptionsSet, useVar } from '@hooks';

const contentContainerStyle: SxProp = {
  px: '$6',
};

const Container = styled(View)({
  flex: 1,
  bg: '$background0',
});

const InputContainer = styled(View)({
  px: '$6',
});

const Title = styled(BaseText)({
  variant: 'text.medium',
  color: '$heading800',
});

type RoutePropType = AppNavigatorRoutePropType<'FormPicker'>;

export function FormPickerScreen() {
  const [search, setSearch] = useState('');
  const { t } = useTranslation();
  const { params } = useRoute<RoutePropType>();
  const nav = useNavigation();
  const eventEmitter = useEventEmitter();
  const fuse = useVar(
    new Fuse(params.options, {
      keys: ['title'],
    }),
  );

  useNavOptionsSet({ title: params.screenTitle });

  function onPressItem(value: string) {
    eventEmitter.emit(params.eventName, { value });
    nav.goBack();
  }

  const listData = useMemo(
    () =>
      search
        ? fuse.search(search).map((i) => i.item)
        : params.options,
    [search],
  );

  return (
    <Container>
      <Separator size="$7" />
      <InputContainer>
        <TextInput
          value={search}
          onChangeText={setSearch}
          placeholder={t('formPicker.placeholder')}
        />
      </InputContainer>

      <FlatList
        data={listData}
        keyExtractor={(_, index) => index.toString()}
        contentContainerSx={contentContainerStyle}
        ItemSeparatorComponent={Line}
        renderItem={({ item }) => (
          <Touchable onPress={() => onPressItem(item.value)}>
            <Separator />
            <Title>{item.title}</Title>
            <Separator />
          </Touchable>
        )}
      />
    </Container>
  );
}
